import styled from 'styled-components';

const SpanCommentLength = styled.div``;

export default SpanCommentLength;
